import axios from "axios";
import instance from "../../../../axios";

export const BASEV2_URL = `${process.env.REACT_APP_API_URL_V2}`;
export const BASE_URL = `${process.env.REACT_APP_API_URL}`;
export const LOCAL_URL = `${process.env.REACT_APP_API_URL_LOCAL}`;
export const BASE_SAAS_URL = `${process.env.REACT_APP_API_URL}`;

export function createItem(item) {
  return instance.post(`${BASEV2_URL}/adDownload/createAd`, item);
}

export function getItemById(id) {
  return instance.get(`${BASEV2_URL}/adDownload/getAdByID/${id}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findItem(queryParams) {
  return instance.post(`${BASEV2_URL}/find`, { queryParams });
}

// UPDATE => PUT: update the StaffUser on the server
// export function updateItem(item) {
//   return instance.post(
//     `${BASEV2_URL}/adDownload/updateAdByID/${item._id}`,
//     item
//   );
// }

export function updateItem(id, item) {
  return instance.post(`${BASEV2_URL}/adDownload/updateAdByID/${id}`, item);
}

export function getContestUsersList(id) {
  return instance
    .post(`${BASEV2_URL}/scrim/getScrimJoinedUser/${id}`)
    .then((res) => {
      return res;
    });
}
export function uploadImage(file) {
  let formData = new FormData();
  formData.append("file", file);

  let url = BASE_URL + "/image/upload";
  return instance.post(`${url}`, formData);
}

export function getCompany(queryParams) {
  return instance
    .post(`${BASE_URL}/country/dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}

export function getCurrency(queryParams) {
  return instance
    .post(`${BASE_URL}/currency/dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}

export function fetchCountriesList(queryParams) {
  return instance.post(`${BASE_URL}/country/list`, queryParams).then((res) => {
    return res;
  });
}

export function fetchCountriesDropdownList(queryParams) {
  return instance
    .post(`${BASE_URL}/country/Dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}
